<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>Sortir un véhicule du parc</span>
        </div>
        <div class="small-modal__body">
          <div class="small-modal__body__block">
            <div
              class="small-modal__body__block--title text-capitalize required"
            >
              <span>date de sortie du parc</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <vue-datepicker-local
                  v-model="vehicle.exit_date"
                  :format="$store.getters.getDateFormat"
                  :local="datepicker_default_local[$store.state.locale]"
                ></vue-datepicker-local>
              </div>
            </div>
          </div>
        </div>
        <div class="small-modal__footer">
          <div class="small-modal__footer__actions">
            <button class="blue-button" @click.prevent="remove">
              <span>Sortir</span>
            </button>
          </div>
        </div>
      </div>
      <ErrorModal
        v-if="isErrorPopup"
        @close="isErrorPopup = false"
        :error="ErrorMessage"
      />
    </div>
  </transition>
</template>

  <script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VueDatepickerLocal from "@/components/VueDatepickerLocal";
import datepickerLocalization from "@/mixins/datepickerLocalization";
import { TheMask } from "vue-the-mask";
import Preloader from "@/components/Preloader";
import Integer from "vuelidate/lib/validators/integer";
import ErrorModal from "@/components/GarantiesSouscrites/ErrorModal";

export default {
  name: "DeleteVehicleModal",
  mixins: [validationMixin, datepickerLocalization],
  components: { VueDatepickerLocal, Preloader, TheMask, ErrorModal },
  props: {
    car: {
      type: Integer,
    },
  },
  data() {
    return {
      vehicle: {
        exit_date: new Date(),
      },
      isErrorPopup: false,
      ErrorMessage: null,
    };
  },
  computed: {},
  methods: {
    closeModal() {
      this.$emit("close");
    },
    remove() {
      if (this.car > 0) {
        this.isBusy = true;
        let url = "mutuaide/assistance/" + this.car,
          data = {
            ...this.vehicle,
            from_partner : true
          };
        data.exit_date = this.moment(this.vehicle.exit_date).format(
          "YYYY-MM-DD 23:59:59"
        );
        this.apiDelete(url, data)
          .then((response) => {
            this.showSuccessNotification("Le véhicule a été sorti du parc.");
            this.$emit("close");
            this.$emit("update-list");
          })
          .catch((error) => {
            this.isErrorPopup = true;
            this.ErrorMessage = error.response.data.message;
          });
      } else {
        this.showErrorNotification("Le véhicule n'a pas été sorti du parc.");
      }
    },
  },
  validations: {
    vehicle: {
      exit_date: {
        required,
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/DeleteVehicleModal.vue